module.exports = __webpack_public_path__ + "static/media/Shadow.0e27da17.svg";